import { createRouter, createWebHistory } from 'vue-router'
import HelloWorld from '../components/HelloWorld.vue'
import ExplorerPage from '../components/ExplorerPage.vue'


const routes = [
  { path: '/', name: 'Home', component: HelloWorld },
  { path: '/explore', name: 'Explore', component: ExplorerPage },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
